<template>
    <div>
        <b-row>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('name')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.name) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('surname')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.surname) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('national_id')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.national_id) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('registration_number')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.registration_number) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('email')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.email) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('corporation')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.company) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('valid_date')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.valid_date) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('birthdate')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.birthdate) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('birthplace')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.birthplace) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('unit')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.unit) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('position')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.position) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('type')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.type) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    //Service
    import IdentityCardService from '@/services/IdentityCardService';

    export default {
        props: {
            formId: {
                type: Number
            }
        },
        data() {
            return {
                form: {
                    type: null,
                    email: null,
                    name: null,
                    surname: null,
                    national_id: null,
                    birthdate: null,
                    birthplace: null,
                    title: null,
                    company: null,
                    unit: null,
                    position: null,
                    valid_date: null,
                    registration_number: null,
                }
            }
        },
        async created() {
            await this.get(this.formId)
        },
        methods: {
            get(id) {
                this.formLoading = true;
                IdentityCardService.get(id)
                                .then((response) => {
                                    this.form = response.data.data;
                                    this.formLoading = false;
                                })
                                .catch((error) => {
                                    this.showErrors(error)
                                });
            }
        }
    }
</script>
